import React from 'react';

/**
 * TODO(AR-517): render `notificationStream.items` as per-kind cards with
 * NEW / EARLIER grouping and a Load More button, paging via `fetchMore` on the
 * query's `$after` using `nextCursor`.
 */
export default function StreamSection() {
  return <div className="notifications-center__stream" />;
}
